
import React from 'react';

const EnhancedSelect = ({ value, onChange, options, disabled = false, className = '' }) => (
  <div className="relative">
    {/* Glassmorphic overlay for the select container */}
    <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent opacity-50 dark:from-white/5 dark:opacity-30 rounded-lg pointer-events-none" />

    <select
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`
    relative z-10 w-full px-2 py-1.5 pr-8 sm:px-4 sm:py-2 sm:pr-10 rounded-lg backdrop-blur-sm border-2 border-border
    bg-background-secondary text-content-primary font-medium text-sm sm:text-base
     focus:ring-primary focus:border-primary
    hover:border-primary/50 transition-all duration-200
    disabled:opacity-50 disabled:cursor-not-allowed
    ${className}
  `}
      style={{
        background: 'var(--color-background-secondary)',
        backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
        backgroundPosition: 'right 12px center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '16px',
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        appearance: 'none',
        outline: 'none', // Remove browser outline
      }}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value} disabled={option.disabled}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);

export default EnhancedSelect;
